import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DashboardOPEEnum} from "./DashboardOPEEnum";

class O {
  id!: number;
}

/**
 * O Inner Class
 */
class I {
  id?: number;
  dashboardId!: number;
  widgetId!: number;
  name!: string;
  colsSize!: number;
  rowsSize!: number;
  colsStart!: number;
  rowsStart!: number;
  userConfig!: any;
  files?: FileStorageDTO[];
  metricInstanceIds!: number[];
}

class FileStorageDTO {
  /**
   * Directory in cui viene salvato il file sullo storage
   */
  directory!: string;

  /**
   * Id univoco e nome del file all'interno della directory
   */
  fileId!: string;

  /**
   * Chiave del file sul bucket di S3
   */
  objKey!: string

}


/**
 * PutDashboardCB class
 */
export class PutDashboardWidgetCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DashboardOPEEnum.PutDashboardWidget);
    this.i = new I();
    this.o = new O();
  }

}
